import { Button } from '@/trailmix/Button';
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalOverlay } from '@chakra-ui/react';
import { Link } from '@inertiajs/react';
import { LocationPin } from '@/components/LocationPin';

// TODO: global modal/shout system?

export function LoginPromptModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} size='lg'>
                <ModalOverlay />
                <ModalContent>
                    <ModalCloseButton />
                    <ModalBody p={0}>
                        <div className='flex flex-col items-center gap-1 px-6 pb-6 pt-8 text-center desktop:gap-2 desktop:pb-8'>
                            <div className='flex flex-col items-center gap-4 desktop:gap-6'>
                                <div className='rounded-md border border-red-200 bg-red-100 p-2'>
                                    <LocationPin className='h-8' />
                                </div>
                                <h1 className='text-2xl font-bold desktop:text-3xl'>Log in to AdventureList</h1>
                            </div>
                            <p className='max-w-md text-pretty font-medium text-gray-700'>
                                Save your favorite places, build your must-visit list, and share your experiences with
                                your friends.
                            </p>
                        </div>
                    </ModalBody>
                    <ModalFooter pt={0} className='flex flex-col gap-2'>
                        <Button as={Link} href={route('register')} variant='primary' className='w-full'>
                            Sign up
                        </Button>
                        <Button as={Link} href={route('login')} className='w-full'>
                            Log in
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}
